<div class="container p-0">
  <div class="row align-items-end">
    <div class="col">
      <div class="slider">
        @if (selectionType=='MinMax') {
          <ngx-slider [(value)]="selectedMin" [(highValue)]="selectedMax" [options]="options"></ngx-slider>
        }
        @if (selectionType=='Single') {
          <ngx-slider [(value)]="selectedMin" [options]="options"></ngx-slider>
        }
      </div>
    </div>
    <div class="col-auto ps-4">
      <button class="btn btn-dark btn-circle send-button" (click)="send()">
        <i class="fa-sharp fa-solid fa-paper-plane-top"></i>
      </button>
    </div>
  </div>
</div>
